import { policyRuleDisplayMessagePlacements } from '@reveni-io/reveni-ui'

import { isConsentRequired } from '@/hooks/useConsentModal/helpers'
import routes from '@/Router/routes.constants'

import { skippableRefundMethods } from './constants'

const isSkipSingleRefundMethodStepEnabled = merchantInfo => {
  return merchantInfo.preferences.skip_single_refund_method_step === true
}

export const getSingleRefundMethodToApply = ({ context, allowedRefundMethods }) => {
  if (!isSkipSingleRefundMethodStepEnabled(context.merchantInfo)) return null
  if (allowedRefundMethods?.length !== 1) return null

  const [{ name }] = allowedRefundMethods

  if (!skippableRefundMethods.includes(name)) return null
  if (isConsentRequired({ context, placement: policyRuleDisplayMessagePlacements.refundMethodPage })) return null

  return name
}

export const getRefundMethodStepRoute = ({ allowedRefundMethods, refundMethodToApply }) => {
  if (refundMethodToApply) return `${routes.summaryPage}?refundType=${refundMethodToApply}`
  if (allowedRefundMethods?.length > 0) return routes.refundSelectionPage

  return routes.summaryPage
}
